import { render, staticRenderFns } from "./ComponentReturnAddress.vue?vue&type=template&id=2bca82cd&"
import script from "./ComponentReturnAddress.vue?vue&type=script&lang=ts&"
export * from "./ComponentReturnAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports